import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CouponValidationService {

private invalidCoupons: Set<number> = new Set();
private hasInvalidCouponLinkSubject = new BehaviorSubject<boolean>(false);
hasInvalidCouponLink$ = this.hasInvalidCouponLinkSubject.asObservable();

setInvalidLinkState(index: number, isInvalid: boolean) {
    if (isInvalid) {
      this.invalidCoupons.add(index);
    } else {
      this.invalidCoupons.delete(index);
    }
    this.hasInvalidCouponLinkSubject.next(this.invalidCoupons.size > 0);
  }
  hasInvalidLinks(): boolean {
    return this.invalidCoupons.size > 0;
  }
  get currentState(): boolean {
    return this.invalidCoupons.size > 0;
  }
    clear() {
    this.invalidCoupons.clear();
    this.hasInvalidCouponLinkSubject.next(false);
  }
}
